import { CircleAlertIcon } from 'lucide-react';
import { useNavigate } from 'react-router';

import { Button } from '@/components/core/button';
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/core/card';
import { Header, HeaderIcon, HeaderTitle } from '@/components/header';
import { Page, PageContent } from '@/components/layout';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <Page>
      <Header>
        <HeaderIcon>
          <CircleAlertIcon />
        </HeaderIcon>
        <HeaderTitle>Page not found</HeaderTitle>
      </Header>
      <PageContent variant="column" className="items-center justify-center">
        <div className="relative w-full max-w-2xl">
          <Card>
            <CardHeader>
              <CardTitle>Sorry, this page does not exist</CardTitle>
              <CardDescription>The link may be outdated or the page moved. </CardDescription>
            </CardHeader>
            <CardFooter>
              <Button
                variant="outline"
                onClick={() => {
                  void navigate(-1);
                }}
              >
                Go back
              </Button>
            </CardFooter>
          </Card>
        </div>
      </PageContent>
    </Page>
  );
}
